import { getEncompassAuthProvider } from './authProviderFactory';
import { React, _ } from '../Imports';
import { useNavigate } from 'react-router-dom';
import { StandardPublicRoutePaths } from '../router/route-sets/standard-route-config';

const styles = require('./Auth.scss') as {
  main: string;
  authMessage: string;
};

export const LogoutResponse: React.FC = () => {
  const navigate = useNavigate();
  const [authProvider] = React.useState(() => getEncompassAuthProvider());

  React.useEffect(() => {
    const handleLogout = async () => {
      await authProvider.logoutCallback?.();
      navigate(StandardPublicRoutePaths.Login);
    };

    handleLogout();
  }, []);

  return (
    <div className={styles.main}>
      <div className={styles.authMessage}>
        <div>Response in process... Completing logout and redirecting...</div>
      </div>
    </div>
  );
};
